var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"search"},[_c('router-link',{staticClass:"searchInput",attrs:{"to":"/mobile/product/search"}},[_c('p',[_vm._v("搜索您需要的机型")]),_c('van-icon',{staticClass:"search-icon",attrs:{"name":"search","size":"24px","color":"#888"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }